<script setup lang="ts">
import { computed } from "vue";

/**
 * A time of day ("HH:MM"), typed or picked with the system's clock. Inline it is the slim filled
 * box of a sentence or a range ("09:00 – 12:00"); with `label` shown it is a field like the others.
 * `end` marks the end of a range: midnight there means the end of the day ("24:00").
 */
const model = defineModel<string>({ default: "" });
const props = withDefaults(
  defineProps<{
    label: string;
    /** Shows the label above the box, as a form field. */
    field?: boolean;
    end?: boolean;
    disabled?: boolean;
    invalid?: boolean;
  }>(),
  { field: false, end: false, disabled: false, invalid: false },
);
const shown = computed({
  get: () => (props.end && model.value === "24:00" ? "00:00" : model.value),
  set: (v: string) => {
    if (!v) return;
    model.value = props.end && v === "00:00" ? "24:00" : v;
  },
});
</script>
<template>
  <label
    v-if="field"
    class="wa-field time-field-box"
    :class="{ error: invalid }"
    ><span>{{ label }}</span
    ><input
      v-model="shown"
      type="time"
      class="time-field"
      step="300"
      :disabled="disabled"
      :aria-invalid="invalid || undefined"
  /></label>
  <input
    v-else
    v-model="shown"
    type="time"
    class="time-field"
    :class="{ invalid }"
    step="300"
    :aria-label="label"
    :disabled="disabled"
    :aria-invalid="invalid || undefined"
  />
</template>
